/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ActivityFields {
	State = "State",
	Subject = "Subject",
	Time = "Time",
	Location = "Location",
	Specification = "Specification",
	Experts = "Experts",
	Attendees_OwnPersonnel = "Attendees_OwnPersonnel",
	Attendees_OrganizationsAndContactPersons = "Attendees_OrganizationsAndContactPersons",
	Attendees_StartUppers = "Attendees_StartUppers",
	Attendees_Immigrants = "Attendees_Immigrants",
	Attendees_JobSeekers = "Attendees_JobSeekers",
	Attendees_LeaderGroupPersons = "Attendees_LeaderGroupPersons",
	Outlook_Attendees = "Outlook_Attendees",
	Outlook_Description = "Outlook_Description",
	Linking_Services = "Linking_Services",
	Linking_Projects = "Linking_Projects",
	Linking_Ventures = "Linking_Ventures",
	Linking_StartedServiceAreas = "Linking_StartedServiceAreas",
	Linking_LeaderProcesses = "Linking_LeaderProcesses",
	InformUsers = "InformUsers",
	InformUserGroups = "InformUserGroups",
	Description = "Description",
	LongDescription = "LongDescription",
	ExpertEmailText = "ExpertEmailText",
	StartupperEmailText = "StartupperEmailText",
	Visibility = "Visibility",
	Attachments = "Attachments",
	SurveyAnswer = "SurveyAnswer",
	SurveyName = "SurveyName",
}
